import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { defaultOption } from "constants/ui/options";
import { nanoid } from "nanoid";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllExpense } from "../../../redux/handlers/logic/getAllExpense.handler";
import { getSupplierFullName, isOverDue, pageInitSize, pageSizeOptions } from "utils/HelperFunction";
import { NumericFormat } from "react-number-format";
import ExpStatus from "fragments/ExpStatus";
export function ExpenseList() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), tab = _useState1[0], setTab = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), tab0 = _useState2[0], setTab0 = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), tab1 = _useState3[0], setTab1 = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), tab2 = _useState4[0], setTab2 = _useState4[1];
    var getAllExpenseReducer = useAppSelector(function(state) {
        return state.getAllExpenseReducer;
    });
    var getData = function() {
        var queryParams = {};
        dispatch(getAllExpense({
            modalObj: modalObj,
            setModalObj: setModalObj,
            queryParams: queryParams
        }));
    };
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        setIsLoading(getAllExpenseReducer.isFetching);
        if (getAllExpenseReducer.data && !getAllExpenseReducer.isError) {
            var result = getAllExpenseReducer.data.data;
            setData(result);
            setTab(result);
            var status0 = result.filter(function(item) {
                return item.dim_mst_expense_status_id === 2 && !isOverDue(item.doc_due_date);
            });
            var status1 = result.filter(function(item) {
                return item.dim_mst_expense_status_id === 3;
            });
            var status2 = result.filter(function(item) {
                return item.dim_mst_expense_status_id === 2 && isOverDue(item.doc_due_date);
            });
            setTab0(status0);
            setTab1(status1);
            setTab2(status2);
        }
    }, [
        getAllExpenseReducer
    ]);
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    var filteredItems = data.filter(function(item) {
        var docNumberMatches = item.doc_number && item.doc_number.toLowerCase().includes(filterText.toLowerCase());
        var supplierNameMatches = item.dimSupplierInformation && getSupplierFullName(item.dimSupplierInformation).toLowerCase().includes(filterText.toLowerCase());
        return docNumberMatches || supplierNameMatches;
    });
    var _useState6 = _sliced_to_array(useState(null), 2), btnempstatus = _useState6[0], setBtnempstatus = _useState6[1];
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่เอกสาร",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(Link, {
                    to: "/financial-accounting/expense/edit/".concat(row.id),
                    className: "text-[#565DFF] font-semibold underline",
                    children: row.doc_number
                });
            }
        },
        {
            field: "supplier_name",
            headerName: "ผู้ขาย",
            flex: 1,
            minWidth: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออก",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "doc_due_date",
            headerName: "กำหนดชำระ",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_due_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.grand_total_price
                });
            }
        },
        {
            headerName: "สถานะ",
            headerAlign: "center",
            field: "dim_mst_expense_status_id",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = isOverDue(row.doc_due_date) ? "overdue" : row.dim_mst_expense_status_id;
                var statusName = isOverDue(row.doc_due_date) ? "เกินกำหนด" : row.dimMstExpenseStatus.name;
                return /*#__PURE__*/ _jsx(ExpStatus, {
                    statusID: statusID,
                    statusName: statusName
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2 mb-4",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-18 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "คลังสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ใบบันทึกค่าใช้จ่าย",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "ใบบันทึกค่าใช้จ่าย"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == null ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(null);
                                    setData(tab);
                                },
                                children: [
                                    "ทั้งหมด",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 0 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(0);
                                    setData(tab0);
                                },
                                children: "รอชำระ"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                    setData(tab1);
                                },
                                children: "ชำระเเล้ว"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 2 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(2);
                                    setData(tab2);
                                },
                                children: "เกินกำหนด"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "รายชื่อพนักงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[300px] mr-auto",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-3 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "เลือกช่วงวันที่ "
                                            }),
                                            /*#__PURE__*/ _jsx(DateRangePicker, {
                                                initialSettings: {
                                                    startDate: moment(),
                                                    endDate: moment().add(1, "days"),
                                                    showCustomRangeLabel: true,
                                                    isCustomDate: true,
                                                    ranges: {
                                                        Today: [
                                                            moment(),
                                                            moment()
                                                        ],
                                                        "Last 7 Days": [
                                                            moment().subtract(6, "days"),
                                                            moment()
                                                        ],
                                                        "Last 30 Days": [
                                                            moment().subtract(29, "days"),
                                                            moment()
                                                        ],
                                                        "This Month": [
                                                            moment().startOf("month"),
                                                            moment().endOf("month")
                                                        ]
                                                    },
                                                    locale: {
                                                        format: "DD/MM/YYYY"
                                                    }
                                                },
                                                children: /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control  h-[44px]"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/financial-accounting/expense/create",
                                    className: "btn btn btn-st-7 mb-2 px-4 !bg-[#565DFF]",
                                    children: "สร้างใบบันทึกค่าใช้จ่าย"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: getAllExpenseReducer.isFetching,
                                getRowId: function(row) {
                                    return "exp-".concat(row.id);
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: filteredItems,
                                columns: columnsd,
                                initialState: {
                                    pagination: {
                                        paginationModel: {
                                            pageSize: pageInitSize
                                        }
                                    }
                                },
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    "& .MuiDataGrid-cell": {
                                        fontSize: "18px",
                                        fontFamily: "Sarabun"
                                    },
                                    "& .MuiDataGrid-columnHeader": {
                                        fontSize: "18px",
                                        fontFamily: "Sarabun"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
